export const APP_ID =
  typeof __app_id !== "undefined" ? __app_id : "clocking-system-v1";

export const LUNCH_START = "12:00";
export const LUNCH_END = "13:30";
export const WORK_START_TIME = "09:00";
export const WORK_END_TIME = "18:00";
export const DUPLICATE_THRESHOLD_MINUTES = 20;

// --- 新增：角色權限定義 ---
export const ROLES = {
  ADMIN: "admin", // 管理員
  FULLTIME: "fulltime", // 正職
  PARTTIME: "parttime", // 工讀生
};

// --- 新增：請假類別定義 ---
export const LEAVE_TYPES = {
  SICK: { id: "sick", label: "病假", requireProof: true },
  PERSONAL: { id: "personal", label: "事假", requireProof: false },
  ANNUAL: { id: "annual", label: "特休", requireProof: false },
  MENSTRUAL: { id: "menstrual", label: "生理假", requireProof: false, annualLimitDays: 3 },
  OTHER: { id: "other", label: "其他", requireProof: false },
};

export const DAILY_WORK_HOURS = 7.5;
